export const getObjectHistoryState = (state) => (
  state && typeof state === 'object' && !Array.isArray(state) ? state : {}
);
